import axios from 'axios';

import DeviceInterceptor from '../device/device.interceptor';
import DeviceService from '../device/device.service';
import { storage } from '../services/storage/storage.service';

const deviceService = new DeviceService(storage, axios);
const deviceInterceptor = new DeviceInterceptor(axios, deviceService);

deviceInterceptor.startIntercepting();
// eslint-disable-next-line @typescript-eslint/no-floating-promises
deviceService.register();

export default deviceService;
